import { createRouter, createWebHashHistory } from "vue-router";

import store from "@/store";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/News.vue"),
  },

  {
    path: "/transport",
    name: "transport",
    component: () => import("@/views/product/Transport.vue"),
  },
  {
    path: "/agreeon",
    name: "agreeon",
    component: () => import("@/views/product/AgreeOn.vue"),
  },
  {
    path: "/finance",
    name: "finance",
    component: () => import("@/views/product/Finance.vue"),
  },
  {
    path: "/ilink",
    name: "ilink",
    component: () => import("@/views/product/ILink.vue"),
  },
  {
    path: "/protect",
    name: "protect",
    component: () => import("@/views/product/Escort.vue"),
  },
  {
    path: "/tech",
    name: "tech",
    component: () => import("@/views/Tech.vue"),
  },

  {
    path: "/system-link",
    name: "system-link",
    component: () => import("@/views/SystemLink.vue"),
  },
  {
    path: "/advice",
    name: "advice",
    component: () => import("@/views/Advice.vue"),
  },
  {
    path: "/industry",
    name: "industry",
    component: () => import("@/views/AdviceIndustry.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutUs.vue"),
  },

  {
    path: "/intro",
    name: "intro",
    component: () => import("@/views/CompanyIntro.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/News.vue"),
  },

  {
    path: "/detail",
    name: "detail",
    component: () => import("@/views/Detail.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const path = to.path;
  store.commit("setActive", path);
  next();
});

export default router;
